export const rarityColors = {
    'COMMON': '#6b7280',        // Grey circle
    'UNCOMMON': '#f3f4f6',      // White open book  
    'RARE': '#cd7f32',          // Bronze triangle
    'SUPER': '#c0c0c0',         // Silver diamond
    'LEGENDARY': '#b8860b',     // Dark gold pentagon
    'SPECIAL': '#ef4444',       // Promo cards
    'ENCHANTED': '#ff6b6b'      // Rainbow hexagon
}; 